module.exports = __webpack_public_path__ + "img/kubernetes.36fdbc6b.png";